import React, { Component, Fragment } from 'react'
import { Container, Row,Col } from 'react-bootstrap'
import hall1D from '../../asset/image/hall1.jpg';
import Chand from '../../asset/image/chandd.jpg';
import summerevent from '../../asset/image/summer.jpg';
import Winterevent from '../../asset/image/winter.jpg';
import past from '../../asset/image/past.jpg';


import { Link } from 'react-router-dom';

export class course extends Component {
  render() {
    return (
     <Fragment>
        <Container  className='text-center courseBackpic'>
              <h1 className='h1Tag'>Explore Our Events</h1>
            <div className='bottom'></div>
            <Row>   
                <Col lg={6} md={12} sm={12} className='p-2'>
                <Row>
                    <Col lg={6} md={6} sm={12}>
                    <img className="courseImage"src={Chand}></img>
                
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Chand Raat Events</h5>
                    <p className='text-justify pTag'> "Night of the Moon," is a festive
                      marking the end of Ramadan. Celebrations typically involve last-minute preparations, socializing, and a vibrant, bustling atmosphere that lasts until the morning of Eid. </p>
                    <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>



                    <Col lg={6} md={6} sm={12} className='p-2'>
                    <img className="courseImage"src={summerevent}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Summer Events</h5>
                    <p className='text-justify pTag'> A summer event description can focus on seasonal themes like warm weather, long days, and outdoor activities, and can be adapted for various occasions like a festival, party, or community gathering.</p>
                        <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>
                    <br/>

                </Row>
               
                
                </Col>


                  <Col lg={6} md={12} sm={12}>
                     <Row>
                    <Col lg={6} md={6} sm={12} className='p-2'>
                    <img className="courseImage"src={Winterevent}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Winter events</h5>
                    <p className='text-justify pTag'> the season is embraced with activities such as snow tubing, polar plunges, admiring ice sculptures, and enjoying local food and hot drinks by outdoor fire pits. Many events take place outdoors</p>
                        <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>



                    <Col lg={6} md={6} sm={12} className='p-2'>
                    <img className="courseImage"src={past}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>All Previous Events</h5>
                    <p className='text-justify pTag'> Here We will have all the past events that we have done</p>
                        <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>

                </Row>
                  
                  </Col>
                    
            </Row>
        </Container>
     </Fragment>
    )
  }
}

export default course
